// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import Radium from 'radium';
import firebase from 'firebase/app';

import {
  Card,
  CardHeader,
  CardBlock,
  FormGroup,
  Container,
  Row,
  Col,
} from 'reactstrap';

import Hero from 'components/Hero';
import EditOptions from 'components/EditOptions';
import Timeline from 'components/Timeline';

// import {
//   loadAssignments,
//   editAssignment,
//   createComment,
// } from 'actions/assignments';

type Props = {
  assignmentId: string,

  // recompose

  // redux
  me: Object,
  // assignment: ?Object,
  // assignments: Array<Object>,
  // employeeLookup: { [uid: string]: string },
  // onLoadAssignments: typeof loadAssignments,
  // onEditAssignment: typeof editAssignment,
  // onCreateComment: typeof createComment,
};

type State = {
  assignment: Object,
};

class AssignmentView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    console.log({ assignmentId: props.assignmentId });
    firebase
      .firestore()
      .doc(`assignments/${props.assignmentId}`)
      .onSnapshot(async snap => {
        const data = snap.data();
        const assignment = {
          ...data,
          images: await Promise.all(
            data.images.map(image =>
              firebase
                .storage()
                .ref(image)
                .getDownloadURL()
            )
          ),
          assignmentId: snap.id,
        };

        this.setState(prevState => ({ ...prevState, assignment }));
      });
  }
  state = {
    assignment: null,
  };

  // async componentDidMount() {
  //   const { assignment, onLoadAssignments } = this.props;
  //   if (!assignment) {
  //     await onLoadAssignments();
  //   }
  // }

  _onAddImage = async image => {
    /**
     * TODO: create add image API
     */
  };

  _onDeleteImage = async index => {
    /**
     * TODO: create remove image API
     */
  };

  _onFieldChange = async (field, value) => {
    // const { assignment, onEditAssignment, onLoadAssignments } = this.props;
    // console.log({ field, value });
    // await onEditAssignment(assignment.assignmentId, {
    //   [field]: value,
    // });
    // await onLoadAssignments();
  };

  _onCommentAdd = async comment => {
    const { me } = this.props;
    const { assignment } = this.state;
    await firebase
      .firestore()
      .doc(`assignments/${assignment.assignmentId}`)
      .update({
        states: [
          ...assignment.states,
          {
            type: 'comment',
            text: comment,
            createdBy: me,
            createdAt: firebase.firestore.Timestamp.now(),
          },
        ],
      });
  };

  render() {
    const {
      me,
      // assignment,
      // employeeLookup,
      // onLoadAssignments,
      // onCreateComment,
    } = this.props;
    const { assignment } = this.state;

    if (!assignment) {
      return <div>Daten werden geladen, bitte warten ...</div>;
    }

    const { title, description, images, createdAt, assignees } = assignment;
    const employeeLookup = Object.keys(assignees).reduce(
      (acc, uid) => ({ ...acc, [uid]: assignees[uid].displayName }),
      {}
    );
    console.log({ assignment });

    const entries = (assignment.states || []).map((state, index) => ({
      type: state.type,
      createdByEmail: state.createdBy.email,
      createdByName: state.createdBy.displayName,
      isCreatedByManager: state.createdBy.uid === me.uid,
      text: state.text,
      createdAt: +state.createdAt.toDate(),
      isOwnEntry: true,
      commentIndex: index,
    }));

    return (
      <div>
        <Container fluid>
          <Row>
            <Col>
              <Hero
                title={title}
                description={description}
                images={images}
                createdAt={createdAt._seconds * 1000}
                onImageAdded={this._onAddImage}
                onImageDeleted={this._onDeleteImage}
                onFieldChanged={this._onFieldChange}
                maxImages={4}
              />
              <Timeline
                entries={entries}
                editable
                onComment={comment => this._onCommentAdd(comment)}
                onReloadData={() => console.log('reload')}
                onCommentEdited={(...args) =>
                  console.log('onCommentEdited', args)
                }
              />
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <Card style={styles.root}>
                <CardHeader style={styles.title}>
                  Zugewiesene Mitarbeiter
                </CardHeader>
                <CardBlock>
                  <FormGroup>
                    <EditOptions
                      optionLookup={employeeLookup}
                      selectedOptions={Object.keys(assignees)}
                      onChange={newAssignees => {
                        // this._onFieldChange('assignees', newAssignees)
                      }}
                    />
                  </FormGroup>
                </CardBlock>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const mapStateToProps = (
  { assignments: { all: assignments }, employees: { all: employees }, auth },
  { match }
) => {
  const me = auth.firebaseUser;
  // const assignment = assignments.find(
  //   a => a.assignmentId === match.params.assignmentId
  // );

  return {
    me,
    assignmentId: match.params.assignmentId,
    // assignments,
    // assignment,
    // employeeLookup: employees.reduce(
    //   (acc, curr) => ({
    //     ...acc,
    //     [curr.uid]: curr.displayName,
    //   }),
    //   {}
    // ),
  };
};
const mapDispatchToProps = {
  // onLoadAssignments: loadAssignments,
  // onEditAssignment: editAssignment,
  // onCreateComment: createComment,
};

const AssignmentViewContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  Radium
)(AssignmentView);

export default AssignmentViewContainer;



// WEBPACK FOOTER //
// ./src/views/Assignment/Assignment.js